import { style } from "@xstyled/styled-components";

export const width = style({
  prop: ["width", "w"],
  css: "width",
});

export const height = style({
  prop: ["height", "h"],
  css: "height",
});
